import { ChainedSchema } from '../../general/ChainedSchema';
class SerializrType_disgardEmptyAspects extends ChainedSchema {
    serializer(context) {
        const allSerializedAspects = this.parentSchema.serializer(context);
        const nonEmptyAspects = Object.entries(allSerializedAspects).reduce((obj, [name, aspect]) => {
            // mhicke: 09.03.2021 : name !== 'preview' can be removed after some while
            // is used to remove obsolete preview images from layout
            if (!!aspect && Array.isArray(aspect.traits) && aspect.traits.length > 0 && name !== 'preview') {
                obj[name] = aspect;
            }
            return obj;
        }, {});
        return nonEmptyAspects;
    }
}
export function disgardEmptyAspects(propSchema) {
    return new SerializrType_disgardEmptyAspects(propSchema);
}
